import { render, staticRenderFns } from "./SystemAssessmentComponent.vue?vue&type=template&id=39765398&scoped=true"
import script from "./SystemAssessmentComponent.vue?vue&type=script&lang=js"
export * from "./SystemAssessmentComponent.vue?vue&type=script&lang=js"
import style0 from "./SystemAssessmentComponent.vue?vue&type=style&index=0&id=39765398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39765398",
  null
  
)

export default component.exports